import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    videoBox: {
        marginBottom: '8px !important',
        '& iframe': {
            border: 'var(--border)',
            borderRadius: 20,
            boxShadow: 'var(--box-shadow)'
        }
    },
    title: {
        color: theme.palette.fg.purple
    },
    ctaBox: {
        marginTop: 80
    }
}))
